import type { StatusPresetMap } from './types'

export type DocType = 'task_doc' | 'technical_doc' | 'user_doc'

export const docTypePresets: StatusPresetMap<DocType> = {
  task_doc: { label: 'Task Doc', tone: 'info' },
  technical_doc: { label: 'Technical Doc', tone: 'neutral' },
  user_doc: { label: 'User Doc', tone: 'success' },
}
